import { select as d3Select } from 'd3-selection'
import * as d3ease from 'd3-ease';

import { useRef, useLayoutEffect } from 'react';
// Tools
import { no_propagate } from './utils';
// Custom hooks
import useAnimated from './useAnimated';
// Constants
import * as constants from './constants';

const Label = ({ person, radius, radius_off_screen, selected_person_change, initial_animation_delay, set_focused_this_person, set_unhighlighted_person, set_selected_this_person }) => {

  const angle = (person.start_angle + person.end_angle) / 2;
  const new_transform = `
                          rotate(${angle * 180 / Math.PI - 90})
                          translate(${radius + 5})
                          ${angle > Math.PI ? "rotate(180)" : ""}
                        `;
  const align_right = angle > Math.PI;

  // Ref for pointing at label ref which we use to get width
  const label_ref = useRef(null);

  // Callback for grabbing new_dx from label_ref
  const get_dx = () => (label_ref.current && align_right) ? -label_ref.current.getBBox().width : 0;

  const [anim_ref, {transform, dx}] = useAnimated({
    attrs : {
      'transform' : new_transform,
      'dx' : get_dx()
    },
    duration : selected_person_change ? constants.SELECTION_ANIM_DURATION : constants.REORDER_ANIM_DURATION,
    deps : [angle]
  });

  let label_text = person.name;
  if (person.group_size > 1) {
    label_text += ` (${person.group_size})`;
  }

  // After initial render (but never again) animate dx, ending
  // at a value based on label_ref.current size
  useLayoutEffect(() => {
    const dx = get_dx()
    const init_dx_delta = radius_off_screen - radius + constants.NODE_THICKNESS;
    const init_dx_delta_signed = align_right ? - init_dx_delta : init_dx_delta;
    d3Select(label_ref.current)
      .attr('dx', dx + init_dx_delta_signed)
      .transition()
      .duration(constants.NODELABEL_INITIAL_ANIM_DURATION)
      .delay(initial_animation_delay * constants.NODELABEL_INITIAL_ANIM_DELAY_RANGE)
      .ease(d3ease.easeBackOut)
      .attr('dx', dx);
  }, []);

  return (
    <text key={`text_${person.person_index}`}
          // We have two refs so set them both up
          ref={(elem) => {label_ref.current = anim_ref.current = elem}}
          data-person_index={person.person_index}
          fill="white"
          dy="0.35em"
          transform={transform}
          dx={dx}
          onMouseEnter={set_focused_this_person}
          onMouseLeave={set_unhighlighted_person}
          onClick={no_propagate(set_selected_this_person)}>
      {label_text}
    </text>
  );
};

export default Label;
